const EventEmitter = require('events');

const SERVER_HOST = 'intrahouse.io';
const SERVER_PORT = 49000;


class TransportClient extends EventEmitter {
  constructor(options) {
    super();
    this.options = { ...options, sessionid: null, transferid: null, token: null };
  }

  open() {

  }

  message(e) {
    const msg = JSON.parse(e.data);

    switch (msg.type) {
      case 'info':
        this.options.sessionid = msg.sessionid;
        this.send('connect_a', { token: this.options.token });
        break;
      case 'channel':
        this.options.transferid = msg.data.transferid;
        this.emit('open', { transferid: this.options.transferid });
        break;
      case 'transferdata':
        this.emit('transferdata', msg);
        break;
      case 'error':
        this.emit('error', msg.data);
        break;
      default:
        break;
    }
  }

  send(type, data) {
    this.client.send(JSON.stringify({
      type,
      data,
      sessionid: this.options.sessionid,
    }));
  }

  transferdata(data) {
    this.client.send(JSON.stringify({
      type: 'transferdata',
      data,
      sessionid: this.options.sessionid,
      transferid: this.options.transferid,
    }));
  }

  close() {
    this.send('close', { transferid: this.options.transferid });
  }

  dispose() {
    this.client = null;
    delete this.client;
  }

  start(token) {
    this.options.token = token;

    this.client = new WebSocket(`ws://${SERVER_HOST}:${SERVER_PORT}`);

    this.client.onopen = this.open.bind(this);
    this.client.onmessage = this.message.bind(this);
    this.client.onclose = this.dispose.bind(this);
  }

}

module.exports = TransportClient;



// WEBPACK FOOTER //
// ./src/lib/transport-client.js